/**
 * api.js — Wrapper fetch centralizzato per myNibble.
 *
 * Sanctum SPA cookie auth: ogni fetch include credentials:'include' (session cookie).
 * CSRF: POST/PUT/PATCH/DELETE iniettano X-XSRF-TOKEN dal cookie XSRF per-app.
 * On-401 → redirect a /login.
 *
 * Le 3 SPA (admin/partner/user) condividono il dominio cookie padre: il backend
 * isola le sessioni emettendo un cookie XSRF per ruolo. Il portale clienti è la
 * app "user" → legge XSRF-TOKEN-user (header invariato X-XSRF-TOKEN).
 * Ref: ADR per-app session isolation — core config/spa.php.
 */

function xsrfToken() {
  const m = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN-user=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : '';
}

const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);

/**
 * fetch autenticato via Sanctum SPA cookie.
 * On-401 redireziona a /login.
 *
 * @param {string} url
 * @param {object} options - opzioni fetch standard (method, body, headers, ...)
 * @returns {Promise<Response>}
 */
export async function apiFetch(url, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const baseHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    ...(!SAFE_METHODS.has(method) ? { 'X-XSRF-TOKEN': xsrfToken() } : {}),
    ...(options.headers || {}),
  };

  const response = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: baseHeaders,
  });

  // On-401 → vai al login, MA non se siamo già su una route pubblica di auth:
  // altrimenti tryLogin (App.vue) → getUser 401 → redirect → reload → loop infinito.
  if (response.status === 401) {
    const path = window.location.pathname;
    const onAuthRoute = path.startsWith('/login')
      || path.startsWith('/forgot-password')
      || path.startsWith('/reset-password');
    if (!onAuthRoute) {
      window.location.href = '/login';
    }
  }

  return response;
}

/**
 * Manteniamo authHeaders per retrocompatibilità con eventuali chiamanti diretti.
 * Post-migrazione non serve più un token: restituisce solo gli header base.
 * @param {object} extra - Header aggiuntivi/override
 * @returns {object}
 */
export function authHeaders(extra = {}) {
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    ...extra,
  };
}
